import congratulationsIcon from 'src/public/img/illustration-smiley-face.svg';
import weekIcon from 'src/public/img/illustrations-wave-of-emotion.svg';

import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';
import { CongratulationsStep } from 'src/modules/programs/stepComponents/CongratulationsStep';

import { CBTProgramStepProps } from '../../models/cbtProgram';
import { HowDidTrackingYourEmotionsGoStep } from '../stepComponents/HowDidTrackingYourEmotionsGoStep';
import { HowDoEmotionsWorkStep } from '../stepComponents/HowDoEmotionsWorkStep';
import { JudgmentsStep } from '../stepComponents/JudgmentsStep';
import { MindfulnessEmotionsPracticeStep } from '../stepComponents/MindfulnessEmotionsPracticeStep';
import { MindfulnessOfEmotionsExerciseStep } from '../stepComponents/MindfulnessOfEmotionsExerciseStep';
import { NonJudgmentalAwarenessStep } from '../stepComponents/NonJudgmentalAwareness';
import { PainVsSufferingStep } from '../stepComponents/PainVsSufferingStep';
import { SummaryOfEmotionsStep } from '../stepComponents/SummaryOfEmotionsStep';
import { WhatDoesAwarenessLookLikeStep } from '../stepComponents/WhatDoesAwarenessLookLikeStep';
import { WhatIsMindfulnessOfEmotionsStep } from '../stepComponents/WhatIsMindfulnessOfEmotionsStep';
import { WhatDoesThisLookLikeStep } from '../stepComponents/WhatThisLookLikeStep';
import { CBTProgramWeekFourStep } from './weekFour';

const steps: (ProgramSharedStep | CBTProgramWeekFourStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CBTProgramWeekFourStep.HowDidTrackingYourEmotionsGoStep,
    CBTProgramWeekFourStep.WhatIsMindfulnessOfEmotionsStep,
    CBTProgramWeekFourStep.WhatDoesAwarenessLookLikeStep,
    CBTProgramWeekFourStep.HowDoEmotionsWorkStep,
    CBTProgramWeekFourStep.WhatDoesThisLookLikeStep,
    CBTProgramWeekFourStep.PainVsSufferingStep,
    CBTProgramWeekFourStep.JudgmentsStep,
    CBTProgramWeekFourStep.NonJudgmentalAwarenessStep,
    CBTProgramWeekFourStep.MindfulnessOfEmotionsExerciseStep,
    CBTProgramWeekFourStep.SummaryOfEmotionsStep,
    ProgramSharedStep.PlanStep,
    ProgramSharedStep.CongratulationsStep,
];

const stepsProps: CBTProgramStepProps[] = [
    {
        id: CBTProgramWeekFourStep.HowDidTrackingYourEmotionsGoStep,
        component: HowDidTrackingYourEmotionsGoStep,
        tooltip: 'How did tracking your emotions go last week?',
        noButtons: true,
    },
    {
        id: CBTProgramWeekFourStep.WhatIsMindfulnessOfEmotionsStep,
        component: WhatIsMindfulnessOfEmotionsStep,
        tooltip: 'What is Mindfulness of Emotions',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekFourStep.WhatDoesAwarenessLookLikeStep,
        component: WhatDoesAwarenessLookLikeStep,
        tooltip: 'What does awareness look like?',
    },
    {
        id: CBTProgramWeekFourStep.MindfulnessOfEmotionsExerciseStep,
        component: MindfulnessOfEmotionsExerciseStep,
        tooltip: 'Practicing mindful awareness?',
        noButtons: true,
    },
    {
        id: CBTProgramWeekFourStep.HowDoEmotionsWorkStep,
        component: HowDoEmotionsWorkStep,
        tooltip: 'How do emotions work?',
    },
    {
        id: CBTProgramWeekFourStep.WhatDoesThisLookLikeStep,
        component: WhatDoesThisLookLikeStep,
        tooltip: 'What does this look like?',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekFourStep.PainVsSufferingStep,
        component: PainVsSufferingStep,
        tooltip: 'What does this look like?',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekFourStep.JudgmentsStep,
        component: JudgmentsStep,
        tooltip: 'Judgments',
        flexGrow: false,
    },
    {
        id: CBTProgramWeekFourStep.NonJudgmentalAwarenessStep,
        component: NonJudgmentalAwarenessStep,
        tooltip: 'What does awareness look like?',
    },
    {
        id: CBTProgramWeekFourStep.SummaryOfEmotionsStep,
        component: SummaryOfEmotionsStep,
        tooltip: 'Summary',
    },
    {
        id: ProgramSharedStep.PlanStep,
        component: MindfulnessEmotionsPracticeStep,
        tooltip: 'This week',
        noButtons: true,
    },
    {
        id: ProgramSharedStep.CongratulationsStep,
        component: CongratulationsStep,
        tooltip: 'Congratulations!',
    },
];

const t = (key: string) => `cbt:week-4.data.${key}`;

export const weekFourData = {
    id: ProgramWeekEnum.WeekFour,
    weekNumber: 3,
    readableWeekNumber: 4,
    iconUrl: weekIcon,
    congratulationsIconUrl: congratulationsIcon,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};
